"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.8 25",
    width: "30.8",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0C18.7,0,24,4.6,24.9,10.7c0,0.3-0.1,0.5-0.4,0.6c-0.3,0-0.5-0.1-0.6-0.4 C23,5.2,18.2,1,12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24c1.9,0,3.8-0.5,5.5-1.4c0.2-0.1,0.5,0,0.7,0.2c0.1,0.2,0,0.5-0.2,0.7 C16.6,24.5,14.6,25,12.5,25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.3,25c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S27.9,25,24.3,25z M24.3,13c-3,0-5.5,2.5-5.5,5.5 s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S27.4,13,24.3,13z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26,19.5h-2.2c-0.3,0-0.5-0.2-0.5-0.5v-3.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.3H26c0.3,0,0.5,0.2,0.5,0.5 S26.2,19.5,26,19.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.9,17.4h-9c-0.8,0-1.4-0.6-1.4-1.4V9.1c0-0.8,0.6-1.4,1.4-1.4h11.2c0.8,0,1.4,0.6,1.4,1.4v3.4c0,0.3-0.2,0.5-0.5,0.5 s-0.5-0.2-0.5-0.5V9.1c0-0.2-0.2-0.4-0.4-0.4H6.9c-0.2,0-0.4,0.2-0.4,0.4v6.9c0,0.2,0.2,0.4,0.4,0.4h9c0.3,0,0.5,0.2,0.5,0.5 S16.2,17.4,15.9,17.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,15.5c-0.1,0-0.2,0-0.3-0.1l-6.2-5c-0.2-0.2-0.2-0.5-0.1-0.7C6,9.5,6.4,9.4,6.6,9.6l5.9,4.7l5.9-4.7 c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7l-6.2,5C12.7,15.5,12.6,15.5,12.5,15.5z"
  }));
};

exports["default"] = _default;